import { render, staticRenderFns } from "./BarcodeGenerator.vue?vue&type=template&id=6c12c17c&"
import script from "./BarcodeGenerator.vue?vue&type=script&lang=js&"
export * from "./BarcodeGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports